import { render, staticRenderFns } from "./InvoicesFilter.vue?vue&type=template&id=6220b24d&scoped=true"
import script from "./InvoicesFilter.vue?vue&type=script&lang=js"
export * from "./InvoicesFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6220b24d",
  null
  
)

export default component.exports